import { SEND_VERIFICATION_LINK, SEND_VERIFICATION_LINK_SUCCESS, SEND_VERIFICATION_LINK_ERROR, SEND_VERIFICATION_LINK_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const SendVerificationLink = (state = initialState, action) => {
  switch (action.type) {
    case SEND_VERIFICATION_LINK:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case SEND_VERIFICATION_LINK_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case SEND_VERIFICATION_LINK_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case SEND_VERIFICATION_LINK_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default SendVerificationLink;
